import styled, { css } from "styled-components";

import {
  BorderWrapper,
  DefaultDeleteTableButton,
  DefaultDeleteTableButtonWrapper,
  DefaultShellWrapper,
} from "@FillInTableContainer/shared/styles/shell.style";

export const ShellWrapper = styled(DefaultShellWrapper)``;
export const ShellBorderWrapper = styled(BorderWrapper)<{
  $isNoDataDisabled: boolean;
}>`
  ${({ $isNoDataDisabled }) =>
    $isNoDataDisabled &&
    css`
      /* opacity: 0.3; */
      pointer-events: none;
      cursor: not-allowed;
    `}
`;

export const DeleteTableButtonWrapper = styled(
  DefaultDeleteTableButtonWrapper,
)``;
export const DeleteTableButton = styled(DefaultDeleteTableButton)``;
